import ViewColorsTooltip from 'swag-client-common/components/partials/cart/view-colors-tooltip/view-colors-tooltip';
import { connect } from 'react-redux';
const mapStateToProps = (_, {
  item: {
    variants,
    prod
  }
}) => ({
  tooltipData: (variants || []).reduce((acc, {
    quantities,
    variantIndex
  }) => {
    const variant = prod === null || prod === void 0 ? void 0 : prod.variants[variantIndex];
    if (!variant) {
      return acc;
    }
    const {
      color,
      name
    } = variant;
    if (prod !== null && prod !== void 0 && prod.sizeDependentPrice) {
      acc.push({
        color,
        name,
        quantitiesData: [{
          quantity: quantities.find(q => q > 0)
        }]
      });
    } else if (prod !== null && prod !== void 0 && prod.size) {
      const quantitiesData = prod === null || prod === void 0 ? void 0 : prod.size.options.map((size, index) => {
        const quantity = quantities[index];
        return {
          size,
          quantity
        };
      });
      acc.push({
        color,
        name,
        quantitiesData
      });
    } else {
      acc.push({
        color,
        name,
        quantitiesData: [{
          quantity: quantities[0]
        }]
      });
    }
    return acc;
  }, [])
});
export default connect(mapStateToProps)(ViewColorsTooltip);